import type * as React from 'react';
import { get } from '@Domain/Api';
import workflowRunKindsFetched, {
	type WorkflowRunKindsFetchedAction,
	type WorkflowRunKindsFetchedPayload,
} from '@Application/WorkflowRuns/WorkflowRunKinds/Actions/workflowRunKindsFetched';
import workflowRunKindsFetchFailed, {
	type WorkflowRunKindsFetchFailedAction,
} from '@Application/WorkflowRuns/WorkflowRunKinds/Actions/workflowRunKindsFetchFailed';
import type FetchWorkflowRunKinds from '@Application/WorkflowRuns/WorkflowRunKinds/Queries/FetchWorkflowRunKinds';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = WorkflowRunKindsFetchedAction | WorkflowRunKindsFetchFailedAction;

/** A referential list of processing run kinds: no tenant, no parameter. */
export default (_query: FetchWorkflowRunKinds) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<WorkflowRunKindsFetchedPayload>(
				`${parameters.api.host}/api/enums/workflow-run-kinds`,
			);

			const action = workflowRunKindsFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = workflowRunKindsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
